export default __webpack_public_path__ + "static/media/HealthTips@2x.b6aa00e1.png";